module.exports = __webpack_public_path__ + "static/media/1c.15091a4a.jpg";